require('./comparativeBarSimple.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

class ComparativeBarSimple extends React.Component {
    getPercentage(value, totalValue) {
        const parsedValue = parseInt(value, 10);
        const parsedTotalValue = parseInt(totalValue, 10);

        return (parsedValue / parsedTotalValue) * 100;
    }

    getWidthAndOffset(width = 0, offset = 0) {
        if (width === 0) {
            return {
                display: 'none',
            };
        } else {
            return {
                width: `${width}%`,
                left: `${offset}%`,
            };
        }
    }

    render() {
        const { firstValue, totalValue, height, color } = this.props;
        const percentage = this.getPercentage(firstValue, totalValue);
        let innerBarStyles = this.getWidthAndOffset(percentage, 0);

        innerBarStyles.backgroundColor = color;

        const innerBar = <div className="comparative-bar-simple__inner" style={innerBarStyles} />;
        let baseComponentStyles = {
            height: height + 'px',
        };

        return (
            <div className="comparative-bar-simple" style={baseComponentStyles}>
                <div className="comparative-bar-simple__wrapper">{innerBar}</div>
            </div>
        );
    }
}

ComparativeBarSimple.propTypes = {
    color: PropTypes.string,
    firstValue: PropTypes.string,
    height: PropTypes.number,
    totalValue: PropTypes.number,
};

ComparativeBarSimple.defaultProps = {
    color: '#0070D9',
    firstValue: '0',
    height: 6,
    totalValue: 0,
};

export { ComparativeBarSimple };
